import { preprocess } from '@artica/assets';
import fog from '../common/fog';
import {
  Color,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
} from 'three';

preprocess('obsidian', function preprocessObsidian(asset) {
  const { materials } = asset;

  const prevMat = materials.Obsidian;
  materials.Obsidian = new MeshPhysicalMaterial();
  MeshStandardMaterial.prototype.copy.call(
    materials.Obsidian,
    prevMat
  );

  materials.Obsidian.roughnessMap = null;
  materials.Obsidian.roughness = 0.66;
  materials.Obsidian.reflectivity = 0.1;
  materials.Obsidian.specularIntensity = 0.1;
  materials.Obsidian.ior = 1.1;
  materials.Obsidian.color = new Color(0.5, 0.5, 0.5);
  materials.Obsidian.metalnessMap = null;
  materials.Obsidian.metalness = 0;
  materials.Obsidian.specularColor = new Color(0, 0, 0);

  materials.M_Woman_Winter_2 = new MeshStandardMaterial({
    color: 0x000000,
  });

  for (const key in materials) {
    const material = materials[key];
    fog(material);
  }

  return asset;
});